export { BatteryPredictionBadgeComponent } from '../components/battery-prediction-badge/battery-prediction-badge.component';
